import './index.css';
import './index.scss';

// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.js');

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
window.wNumb = require('wnumb');

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
window.toastr = require('toastr/build/toastr.min');

// tiny-slider
import { tns } from 'tiny-slider/src/tiny-slider';
window.tns = tns;

// jquery-highlight
window.jqueryhighlight = require('jquery-highlight');

// js-cookie
window.jscookie = require('js-cookie');

// flatpickr
window.flatpickr = require('flatpickr');

// tippy tooltip
import tippy from 'tippy.js';
window.tippy = tippy;

// lightbox2
window.lightbox2 = require('lightbox2/dist/js/lightbox.js');

// croppie
window.croppie = require('croppie/croppie.js');

window.AjaxCall = require('@/src/js/app/custom/ajaxcall');
window.AjaxDeferred = require('@/src/js/app/custom/ajaxdeferred');
window.AjaxFiles = require('@/src/js/app/custom/ajaxfiles');
window.FlatPicker = require('@/src/js/app/custom/flatpicker');
window.Highlight = require('@/src/js/app/custom/highlight');
window.Modal = require('@/src/js/app/custom/modal');
window.Partnering = require('@/src/js/app/custom/partnering');
window.Session = require('@/src/js/app/custom/session');
window.Toast = require('@/src/js/app/custom/toast');
window.Tooltips = require('@/src/js/app/custom/tooltips');
window.TooltipsDatatable = require('@/src/js/app/custom/tooltips_datatable');

import '@/src/js/app/base/main';

import '@/src/vendors/drupal/drupal';
import '@/src/vendors/drupal/drupalSettingsLoader';
